/* Shared Impact adapter. Load once globally after theme.js. */
(() => {
  if (window.__ptProductRuntime) return;
  window.__ptProductRuntime = true;

  const root = document.documentElement;
  const panelSelector = '.shopify-section--main-product .product-info';
  const quickAddSelector = '.shopify-section--main-product product-quick-add';
  let panels = [];
  let quickAdds = [];
  let generation = 0;
  let panelObserver;
  let quickResize;
  let quickClassObservers = [];

  function isMainForm(form) {
    if (!form || form.tagName !== 'FORM' || !form.matches('form[is="product-form"]')) return false;
    const section = form.closest('.shopify-section--main-product');
    if (!section || !section.isConnected) return false;
    const formId = form.getAttribute('id');
    return !!formId && !!section.querySelector(`product-rerender[observe-form="${CSS.escape(formId)}"]`);
  }

  document.addEventListener('variant:change', event => {
    const form = event.target;
    if (!isMainForm(form)) return;
    const variant = event.detail?.variant;
    if (!variant || typeof variant !== 'object' || !/^[1-9]\d*$/.test(String(variant.id))) return;
    if (typeof variant.price !== 'number' || !Number.isSafeInteger(variant.price) || variant.price < 0) return;
    const formId = form.getAttribute('id');
    const productId = formId.match(/^product-form-(\d+)-/)?.[1];
    if (!productId || (variant.product_id != null && String(variant.product_id) !== productId)) return;
    // Redeemly's saved widget listens on document and reads detail.variant.price.
    // Keep Impact's original event intact for gallery, title, and callout listeners.
    document.dispatchEvent(new CustomEvent('variant:changed', {
      detail: { variant, formId, productId }
    }));
  });

  function updateQuickAdd() {
    if (!window.matchMedia('(max-width: 699px)').matches) {
      root.style.removeProperty('--pt-chat-quick-add-offset');
      return;
    }
    const heights = quickAdds.filter(el => el.isConnected && el.classList.contains('is-visible'))
      .map(el => el.getBoundingClientRect().height);
    if (heights.length) root.style.setProperty('--pt-chat-quick-add-offset', `${Math.ceil(Math.max(...heights) + 16)}px`);
    else root.style.removeProperty('--pt-chat-quick-add-offset');
  }

  function refresh() {
    generation++;
    const current = generation;
    panelObserver?.disconnect();
    panels = Array.from(document.querySelectorAll(panelSelector));
    root.removeAttribute('data-pt-main-purchase-in-view');
    if (typeof IntersectionObserver === 'function' && panels.length) {
      const visible = new Set();
      panelObserver = new IntersectionObserver(entries => {
        if (current !== generation) return;
        for (const entry of entries) {
          if (!panels.includes(entry.target) || !entry.target.isConnected) continue;
          if (entry.isIntersecting) visible.add(entry.target);
          else visible.delete(entry.target);
        }
        root.toggleAttribute('data-pt-main-purchase-in-view', visible.size > 0);
      });
      panels.forEach(panel => panelObserver.observe(panel));
    } else panelObserver = undefined;

    quickResize?.disconnect();
    quickClassObservers.forEach(observer => observer.disconnect());
    quickClassObservers = [];
    quickAdds = Array.from(document.querySelectorAll(quickAddSelector));
    if (typeof ResizeObserver === 'function') {
      quickResize = new ResizeObserver(updateQuickAdd);
      quickAdds.forEach(el => quickResize.observe(el));
    }
    if (typeof MutationObserver === 'function') quickAdds.forEach(el => {
      const observer = new MutationObserver(updateQuickAdd);
      observer.observe(el, { attributes: true, attributeFilter: ['class'] });
      quickClassObservers.push(observer);
    });
    updateQuickAdd();
  }

  // Impact replaces product-rerender descendants. Reconcile after its listeners run.
  document.addEventListener('product:rerender', () => queueMicrotask(refresh), true);
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', () => queueMicrotask(refresh));
  window.addEventListener('resize', updateQuickAdd);
  refresh();
})();
